import DocumentCard from './DocumentCard'
import ExportDocumentsCard from './ExportDocumentsCard'
import useDocuments from './useDocuments'
import DOCUMENT_CONFIGS from './documentConfig'
import { CardsWrapper } from './style'
import { strings } from '@constants'

// Single-valued fields hold one path (or null); array fields hold a list. Array
// fields may still carry a legacy single string, so coerce before filtering.
const normalize = (value, isArray) =>
	isArray ? (Array.isArray(value) ? value : value != null ? [value] : []).filter(Boolean) : [value].filter(Boolean)

// `viewField` items are objects ({ path, ... }); older data may still hold plain path strings.
const toPath = (doc) => (typeof doc === 'string' ? doc : doc?.path)

const docsFor = (invoiceData, { field, viewField, isArray }) =>
	viewField ? normalize(invoiceData?.[viewField], true).map(toPath).filter(Boolean) : normalize(invoiceData?.[field], isArray)

const Documents = ({ supplierPoNumber, update, editable = false }) => {
	const d = useDocuments(supplierPoNumber, update)

	return (
		<CardsWrapper>
			{DOCUMENT_CONFIGS.filter((config) => (!config.buyerOnly || d.isBuyer) && (!config.supplierOnly || !d.isBuyer)).map((config) => (
				<DocumentCard
					key={config.typeKey}
					config={config}
					documents={docsFor(d.invoiceData, config)}
					title={config.typeKey === 'invoice' ? strings(supplierPoNumber ? 'bill' : 'invoice') : undefined}
					uploadLabel={config.typeKey === 'invoice' ? strings(['upload', supplierPoNumber ? 'bill' : 'invoice']) : undefined}
					onUpload={config.typeKey === 'invoice' ? d.uploadInvoiceDoc : (files) => d.uploadDoc(files, config.typeKey, config.field)}
					onDelete={config.typeKey === 'invoice' ? undefined : d.deleteDoc}
					editable={editable}
				/>
			))}
			{d.isBuyer && (
				<ExportDocumentsCard
					invoiceData={d.invoiceData}
					userData={d.userData}
					uploadExportDoc={d.uploadExportDoc}
					deleteExportDoc={d.deleteExportDoc}
					editable={editable}
				/>
			)}
		</CardsWrapper>
	)
}

export default Documents
